var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHydra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(0, 0, 0, 0.7);}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M68.66,32.83a9.18,9.18,0,1,1,9.19-9.18,9.17,9.17,0,0,1-9.19,9.18h0m9.2-29.69V14.78a12.74,12.74,0,0,0-9.5-4.29,13.16,13.16,0,0,0,0,26.32,12.7,12.7,0,0,0,9.5-4.28v3.93h4V3.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.5,32.83a9.18,9.18,0,1,1,9.19-9.18,9.18,9.18,0,0,1-9.19,9.18m9.2-22v4a12.68,12.68,0,0,0-9.49-4.28,13.16,13.16,0,0,0,0,26.31,12.69,12.69,0,0,0,9.49-4.28v3.93h4V10.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87,36.51V10.79h4v3.68a11,11,0,0,1,8.88-4v4c-5.51,0-8.72,2.75-8.88,7.34v14.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.24,21.2H6.32V10.8h-4V36.5h4V24.88H22.24V36.5h4V10.8h-4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.64,37.18a4.59,4.59,0,0,1-4,2.67H32.91v4h2.61a8.42,8.42,0,0,0,7.73-5.1l11.93-28H50.89Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.55,25.71l-6.8-14.92H29.46l8.95,20Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydra);
export default __webpack_public_path__ + "relatointegrado2022/static/media/hydra.f037573c66eb8ee5db7d16b743442f86.svg";
export { ForwardRef as ReactComponent };